export const CAKE_TYPE = {
  EGG_LESS: "EGGLESS",
  WITH_EGG: "WITH EGG",
};

export const constants = {
  DOMAIN_ID: "fnp.com",
  NoOfReviewRequest: 13,
  infoCircleGraySvg: "/icons/info-circle-gray.svg",
  ADD_TO_CART: "Add To Cart",
  ADD_TO_CART_ICON: "/icons/cart-olive-green.svg",
  BUY_NOW: "Buy Now",
  BUY_NOW_ICON: "/icons/cart-buy-now.svg",
  GO_TO_CART: "Go To Cart",
  GIFT_ADDED_TO_CART: "Gift added to cart.",
  SCREEN_SIZE: 1024,
  ANDROID: "Android",
  PRODUCT_DESCRIPTION: "Description",
  CARE_INSTRUCTIONS: "Instructions",
  DELIVERY_INFORMATION: "Delivery Info",
  ctId: "app_offers_module",
  SELECT_DELIVERY_DATE_AND_TIME: "Select Delivery Date & Time Slot",
  OFFERS_AVAILABLE: "Offers Available",
  GIFT_NOW_PAY_LATER: "Gift Now, Pay Later",
  ABOUT_THE_PRODUCT: "About the product",
  GIFT_RECEIVER_LOCATION: "Gift Receiver’s Location",
  COUNTRY_CHANGE: "Changing country?",
  REDIRECTED_TO: "You will be redirected to",
  CATALOG: "catalog",
  CHANGE_PHOTO: "Change Photo",
  CHANGE_AUDIO: "Change Audio",
  UPLOAD_PHOTO: "Upload Photo",
  UPLOAD_AUDIO: "Upload Audio",
  UPLOAD_PHOTOS: "Upload Photos",
  SUCCESSFULLY_UPLOADED: "Successfully Uploaded",
  UPLOADING: "Uploading",
  WINDOW_REFRESH_MESSAGE: "Do not close the window or refresh.",
  SUCCESS: "success",
  INFO: "info",
  PERSONALIZED_HEADING: "Add Personalised Details",
  FILE_SIZE_TEXT: "File size should be between",
  FILE_SIZE: "File Size",
  FORMAT: "Format",
  ONLY: "Only",
  SMALLCASE_ONLY: "only",
  IMAGE: "IMAGE",
  TEXT: "TEXT",
  AUDIO: "AUDIO",
  INSTRUCTIONS: "Instructions",
  INSTRUCTIONS_LIST_LINE_ONE: "File size should be",
  INSTRUCTIONS_LIST_LINE_TWO: "Upload only",
  INSTRUCTIONS_LIST_LINE_THREE: "Please upload a good quality image.",
  INSTRUCTIONS_LIST_LINE_FOUR: "Please ensure you have rights to use the image.",
  DELETE: "Delete?",
  DELETE_MESSAGE: "Are you sure you want to delete this photo?",
  YES: "YES",
  NO: "NO",
  PLEASE_UPLOAD_ALL_PHOTOS_TO_CONTINUE: "Please upload all photos to continue.",
  PLEASE_CHECK_THE_INSTRUCTION_AGAIN: "Please check the instructions again",
  PHOTOS_UPLOADED_SUCCESSFULLY: "Successfully Uploaded!",
  MESSAGE_ON_CAKE: "Message On Cake",
  ADD_PERSONALISED_TEXT: "Add Personalised Text",
  CUSTOMIZE_PRODUCT: "Customize Product",
  SAVE_AND_CONTINUE: "Save & Continue",
  NEXT: "Next",
  CONTINUE_WITH_DETAILS: "Please fill all details to continue.",
  SAVED_SUCCESSFULLY: "Saved successfully",
  AVAILABLE_COMBOS: "Available Combos",
  SMALLCASE_TEXT: "Text",
  ENTERED_TEXT: "Entered text",
  UPLOAD_PERSONALIZE_IMAGE: "Upload Personalize Image",
  SEO_KEYWORD: "Gift, Ferns N Petals, FNP",
  NOTIFICATION_FOR_CART: "Gift has been added to your cart.",
  VIEW_CART: "View Cart",
  PROCEED_TO_CHECKOUT: "Proceed To Checkout",
  PRODUCT_CANNOT_DELIVERED: "This item isn't available at this location. Tap below to explore available gifts.",
  VIEW_AVAILABLE_GIFTS: "View Available Gifts",
  SHOW_SIMILAR: "Explore Available Products",
  REDIRECT_TO_GIFTS_LP: "/all-gifts-lp",
  AVAILABLE_OPTIONS: "Available Options",
  EXPRESS_DELIVERY: "Express",
  COURIER_DELIVERY: "Courier",
  COURIER_NOT_AVAILABLE: "Courier delivery is not available at entered location",
  HAND_NOT_AVAILABLE: "Hand delivery is not available at entered location",
  FAST_DELIVERY_AVAILABLE: "Faster delivery options available",
  NOT_AVAILABLE: "Not Available",
  EARLIEST_BY: "Earliest by",
  SOLD_OUT: "Sold Out",
  CUSTOMIZE_NOW: "Customize Now",
  NEW_CUSTMOIZATION: "Customization",
  UPLOAD_CUSTOMIZE_PHOTOS: "Upload Photos & Customize",
  EDIT: "Edit",
  CHANGE_PHOTOS: "Change Photos",
  ENTER_TEXT: "Enter Text",
  CONTINUE: "Continue",
  MODIFY_YOUR_ORDER: "Modify Your Order",
  SELECT_FLAVOR: "Select Flavour",
  DELIVERY_DATE_AND_TIME_SLOT_VALIDATION: "Please Select Delivery Date & Time Slot",
  CHANGE_PHOTO_AND_CUSTOMIZE: "Change Photo & Customize",
  UPLOAD_PHOTO_AND_CUSTOMIZE: "Upload Photo & Customize",
  THIS_IS_REQUIRED: "This is required",
  TAP_TO_ZOOM: "Tap to zoom",
  TIME_LEFT_TO_GET_DELIVERED: "Time left to get delivered today",
  ROLL_OVER_IMAGE: "Roll over image to zoom in",
  CLICK_TO_OPEN_EXPANDED_VIEW: "Click to Open expanded view",
  SURGE_PRICING: "Surge Pricing",
  DELIVERY_NOT_AVAILABLE: "Delivery is not available on this date.",
  TERMS_N_CONDITIONS: "Terms & Conditions",
  CUSTOMIZE_PREVIEW: "Change Text & customize",
  ADD_TEXT_N_PREVIEW: "Add text & preview your personalised product.",
  SELECT_TIME_SLOT: "Time Slot",
  SELECT_AN_OPTION: "Select an option",
  TODAY: "Today",
  TOMORROW: "Tomorrow",
  LATER: "Later",
  SELECT_DATE_PDP: "Please Select Delivery Date",
  MINIMUM: "Minimum",
  MAXIMUM: "Maximum",
  FREE: "FREE",
  THIRTY_SIXTY_MINUTES: "30-60 min",
  INSTANT_DELIVERY: "Instant delivery",
  MAX_1_QUANTITY_ALLOWED: "Max. 1 quantity is allowed",
  CURRENT_PRODUCT_ID: "current_product_id",
  KEY_HIGHLIGHTS_COUNT: "keyHighlightsCount",
  FOCUS_INVENTORY_OUT_OF_STOCK_MSG: "Product unavailable for the selected date and location.",
  TOTAL_ORDER_VALUE: "Total order value",
  VIEW_PLAN: "View Plan",
  CHOOSE_DELIVERY_PREFERENCE: "Choose Delivery Preference",
  DELIVERY_LOCATION: "Delivery Location",
  CHOOSE_DELIVERY_DATE: "Choose delivery date",
};

export const productTypes = {
  COURIER: "COURIER",
  EXPRESS: "EXPRESS",
  CAKE: "CAKE",
  INTERNATIONAL: "INTERNATIONAL",
  PERSONALIZED: "PERSONALIZED",
  DIGITAL_GOOD: "DIGITAL_GOOD",
  FINISHED_GOOD: "FINISHED_GOOD",
  FREE_SHIPPING: "FREE_SHIPPING",
};

export const labelStyle = "text-16 md:text-14 lg:text-16 font-600 pb-12 leading-18";

export const newLabelStyle = "flex w-full items-center text-12 md:text-14 font-500 leading-16 text-grey-500 mb-8 gap-4";

export const toastFullWidthGapsStyles = "fixed z-[99999] inset-x-20";

export const toastDrawerFullWidthGapsStyles = "absolute z-[99999] left-20 right-20";

export const toastDesktopLayoutStyles =
  "fixed z-[99999] flex w-full items-center justify-center left-1/2 -translate-x-1/2 min-w-[360px] max-w-[420px]";

export const toastStyles = `${toastFullWidthGapsStyles} md:inset-x-auto md:left-1/2 md:-translate-x-1/2 md:min-w-[360px] md:max-w-[420px]`;

export const toastMobilePositionStyles = "bottom-120";

export const toastDesktopPositionStyles = `${toastMobilePositionStyles} md:bottom-auto md:top-140`;

export const toastDrawerPositionStyles = "bottom-[120px]";

export const toastDrawerStyles = `${toastDrawerFullWidthGapsStyles} ${toastDrawerPositionStyles}`;

/**
 * UPLOAD_PHOTOS Constant
 * @param {*} maxInputRequired
 * @returns
 */
export const UPLOAD_PHOTOS = (maxInputRequired) => {
  return `Upload ${maxInputRequired} Photos`;
};

export const metrics = [
  {
    icon: "/icons/year-of-trust.svg",
    value: "25+",
    description: "Years of Trust and Service",
  },
  {
    icon: "/icons/smile.svg",
    value: "108K+",
    description: "Happy customers served",
  },
  {
    icon: "/icons/world.svg",
    value: "30+",
    description: "Countries has branches",
  },
];

/**
 * serenadeProductNotification
 * @param {*} multiOrderProductDetails
 * @returns
 */
export const serenadeProductNotification = (multiOrderProductDetails) => {
  return `The date you’re selecting would be the start date of your service and your product would be delivered for the next ${multiOrderProductDetails?.noOfDays} days.`;
};

export const CTapCampaignConstants = {
  PDP_FREE_GIFT_TOPIC_NAME: "free-gift-tag",
};

export const PRODUCT_VIDEO_POSITION = 1;

export const S3_IMAGE_DOMAIN = ".amazonaws.com";

export const JS_LIBRARY_LINKS = ["/assets/min/jquery-lib-bb.min.js", "/assets/js/custom/three.min.js"];
export const INSTANT = "Instant";
export const SALE_NUDGE = "saleNudge";
export const LOADER = "loader";

export const INSTANT_DELIVERY_INFO_PREFIX = "Get it in";
export const INSTANT_DELIVERY_INFO_SUFFIX = "or choose your preferred delivery slot in the next step.";
export const DELIVERY_SHOULD_BE_SCHEDULED_MESSAGE = "A different location may change delivery schedule.";

export const clearCartConstants = {
  TITLE: "Review Cart",
  WARNING_TEXT: "Below item(s) are not available at ",
  WARNING_TEXT_COUNTRY_CHANGE: "Items in you cart will be cleared on changing the delivery country.",
  VIEW_CART: "View Cart",
  CHANGE_COUNTRY: "Change Country",
  CHANGE_LOCATION: "Change Location",
};
